import { Grid } from "@material-ui/core";
import AppHeader from "@saleor/components/AppHeader";
import { ConfirmButtonTransitionState } from "@saleor/components/ConfirmButton";
import Container from "@saleor/components/Container";
import Form from "@saleor/components/Form";
import PageHeader from "@saleor/components/PageHeader";
import SaveButtonBar from "@saleor/components/SaveButtonBar";
import { SubscriptionErrorFragment } from "@saleor/fragments/types/SubscriptionErrorFragment";
import { SubscriptionFragment } from "@saleor/fragments/types/SubscriptionFragment";
import { sectionNames } from "@saleor/intl";
import { maybe } from "@saleor/misc";
import { concat } from "lodash-es";
import React from "react";
import { useIntl } from "react-intl";

import SubscriberDetails from "../SubscriberDetails/SubscriberDetails";

export interface SubscriberPageFormData {
  email: string;
  active: boolean;
}

export interface SubscriberPageProps {
  subscriber: SubscriptionFragment | null;
  disabled: boolean;
  saveButtonBarState: ConfirmButtonTransitionState;
  onBack: () => void;
  onDelete: () => void;
  onSubmit: (data: SubscriberPageFormData) => void;
  errors: SubscriptionErrorFragment[];
  title: string;
}

const SubscriberPage: React.FC<SubscriberPageProps> = ({
  subscriber,
  disabled,
  errors,
  saveButtonBarState,
  onBack,
  onDelete,
  onSubmit,
  title
}) => {
  const intl = useIntl();
  const initialForm: SubscriberPageFormData =
    subscriber === null
      ? {
          email: "",
          active: false
        }
      : {
          email: maybe(() => subscriber.email, ""),
          active: maybe(() => subscriber.active, false)
        };

  const handleSubmit = (data: SubscriberPageFormData) =>
    onSubmit({
      ...data
    });

  return (
    <Form initial={initialForm} onSubmit={handleSubmit}>
      {({ change, data, hasChanged, submit }) => (
        <Container>
          <AppHeader onBack={onBack}>
            {intl.formatMessage(sectionNames.subscribers)}
          </AppHeader>
          <PageHeader
            title={
              subscriber === null
                ? intl.formatMessage({
                    defaultMessage: "Create New Subscriber",
                    description: "create new subscriber"
                  })
                : maybe(() => concat(subscriber.email))
            }
          />
          <Grid>
            <div>
              <SubscriberDetails
                errors={errors}
                data={data}
                disabled={disabled}
                onChange={change}
                title={title}
              />
            </div>
          </Grid>
          <SaveButtonBar
            disabled={disabled || !hasChanged}
            state={saveButtonBarState}
            onCancel={onBack}
            onSave={submit}
            onDelete={subscriber === null ? undefined : onDelete}
          />
        </Container>
      )}
    </Form>
  );
};
export default SubscriberPage;
